/* ============================================================
 * pn-custom.js — Project Nursery custom JavaScript
 * ------------------------------------------------------------
 * PURPOSE: Home for SELF-CONTAINED custom JS, kept OUT of Icon's
 * theme.js so Icon's admin "update" button can't wipe it.
 * Loaded from snippets/foot-content.liquid (end of <body>).
 *
 * NOTE: Not all custom JS can live here. Customizations that patch
 * the INSIDE of Icon's own functions (e.g. the Infinite Options
 * add-to-cart fix, the product:variant-change event dispatch, the
 * Flickity imagesLoaded tweak) must stay inline in theme.js — they
 * are tagged there with `// PN:` comments so they're easy to find
 * and re-apply after an Icon update (grep "// PN:" theme.js).
 * See THEME-UPDATE-STRATEGY.md.
 * ============================================================ */

(function () {
  function pnInitDelayedHover() {
    // Delayed hover for dropdown menus (extracted from theme.js).
    // Change hoverDelay to adjust the delay (in milliseconds).
    var dropdownMenuItems = document.querySelectorAll(".navigation__menuitem--dropdown");
    var nestedDropdownItems = document.querySelectorAll(".dropdown__menuitem--nested, .megamenu__listitem--nested");
    var hoverDelay = 300; // 300ms — balance for preventing accidental triggers
    var hoverTimeout;
    var nestedHoverTimeout;

    dropdownMenuItems.forEach(function (menuItem) {
      menuItem.addEventListener('mouseenter', function () {
        if (hoverTimeout) {
          clearTimeout(hoverTimeout);
        }
        hoverTimeout = setTimeout(function () {
          menuItem.classList.add('dropdown--delayed-hover');
        }, hoverDelay);
      });

      menuItem.addEventListener('mouseleave', function () {
        if (hoverTimeout) {
          clearTimeout(hoverTimeout);
          hoverTimeout = null;
        }
        menuItem.classList.remove('dropdown--delayed-hover');
      });
    });

    nestedDropdownItems.forEach(function (nestedItem) {
      nestedItem.addEventListener('mouseenter', function () {
        if (nestedHoverTimeout) {
          clearTimeout(nestedHoverTimeout);
        }
        nestedHoverTimeout = setTimeout(function () {
          nestedItem.classList.add('dropdown--delayed-hover');
        }, hoverDelay);
      });

      nestedItem.addEventListener('mouseleave', function () {
        if (nestedHoverTimeout) {
          clearTimeout(nestedHoverTimeout);
          nestedHoverTimeout = null;
        }
        nestedItem.classList.remove('dropdown--delayed-hover');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pnInitDelayedHover);
  } else {
    pnInitDelayedHover();
  }
})();
